export const formatterSsn = (value: string) => {
  if (!value) return '';

  const numericValue = value
    .toString()
    .replace(/\D/g, '')
    .replace(/[^0-9-]/g, '');

  if (numericValue.length === 3) {
    return `${numericValue}-`;
  } else if (numericValue.length === 5) {
    return `${numericValue.slice(0, 3)}-${numericValue.slice(3)}-`;
  } else if (numericValue.length > 5) {
    return `${numericValue.slice(0, 3)}-${numericValue.slice(
      3,
      5
    )}-${numericValue.slice(5, 9)}`;
  }

  return value.replace(/[^0-9-]/g, '');
};

export const formatterPhone = (value: string) => {
  if (!value) return '';

  const numericValue = value
    .toString()
    .replace(/\D/g, '')
    .replace(/[^0-9-]/g, '');

  if (numericValue.length === 3) {
    return `${numericValue}-`;
  } else if (numericValue.length === 6) {
    return `${numericValue.slice(0, 3)}-${numericValue.slice(3)}-`;
  } else if (numericValue.length >= 9) {
    return `${numericValue.slice(0, 3)}-${numericValue.slice(
      3,
      6
    )}-${numericValue.slice(6, 10)}`;
  }

  return value.replace(/[^0-9-]/g, '');
};

export const formatterDate = (value: string) => {
  if (!value) return '';

  if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
    const date = new Date(value);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  const numericValue = value.replace(/\D/g, '');

  if (numericValue.length <= 2) {
    return numericValue;
  } else if (numericValue.length <= 4) {
    return `${numericValue.slice(0, 2)}/${numericValue.slice(2)}`;
  } else if (numericValue.length <= 8) {
    let mm = numericValue.slice(0, 2);
    let dd = numericValue.slice(2, 4);
    let yyyy = numericValue.slice(4, 8);

    // Solo validar si la fecha está completa (8 dígitos)
    if (numericValue.length === 8) {
      const inputDate = new Date(`${yyyy}-${mm}-${dd}`);
      const today = new Date();
      today.setHours(0,0,0,0);

      const minDate = new Date(today);
      minDate.setFullYear(today.getFullYear() - 100);

      // Si la fecha es menor a la mínima, retorna la mínima
      if (inputDate < minDate) {
        const minMM = String(minDate.getMonth() + 1).padStart(2, '0');
        const minDD = String(minDate.getDate()).padStart(2, '0');
        const minYYYY = minDate.getFullYear();
        return `${minMM}/${minDD}/${minYYYY}`;
      }
      // Si la fecha es mayor a hoy, retorna hoy
      if (inputDate > today) {
        const maxMM = String(today.getMonth() + 1).padStart(2, '0');
        const maxDD = String(today.getDate()).padStart(2, '0');
        const maxYYYY = today.getFullYear();
        return `${maxMM}/${maxDD}/${maxYYYY}`;
      }
    }

    return `${mm}/${dd}/${yyyy}`;
  }

  return `${numericValue.slice(0, 2)}/${numericValue.slice(2, 4)}/${numericValue.slice(4, 8)}`;
};

export const formatterDateProcessing = (value: string) => {
  const date = new Date(`${value}T00:00:00`);

  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
  });
}

export const formatterCurrency = (value: any, decimal?: boolean) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: !decimal ? 0 : 3,
  });

  return formatter.format(value);
};

export const capitalizeNames = (text: string) => {
  // Dividir el texto en palabras usando espacios como delimitadores
  let words = text.split(' ');
  // Capitalizar cada palabra y unirlas nuevamente
  let capitalizedWords = words.map(word => {
    // Solo capitalizar si la palabra no está vacía
    if (word) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
    return word;
  });
  // Unir las palabras nuevamente en una sola cadena
  return capitalizedWords.join(' ');
}

export const formatPriceResume = (number: number) => {
  if (!number) return null;

  if (number >= 1e9) {
    const billions = number / 1e9;
    return billions % 1 === 0 ? `$${billions.toFixed(0)}B` : `$${billions.toFixed(1)}B`;
  } else if (number >= 1e6) {
    const millions = number / 1e6;
    return millions % 1 === 0 ? `$${millions.toFixed(0)}M` : `$${millions.toFixed(1)}M`;
  } else if (number >= 1e3) {
    const thousands = number / 1e3;
    return thousands % 1 === 0 ? `$${thousands.toFixed(0)}K` : `$${thousands.toFixed(1)}K`;
  } else {
    return '$' + number.toString(); // Números menores a 1,000 sin formato
  }
};

// Function to format phone number to (XXX) XXX-XXXX format
export const formatPhoneNumber = (phone: string) => {
  if (!phone) return '';
  
  // Remove all non-digits
  const cleaned = phone.replace(/\D/g, '');
  
  // Check if we have a valid phone number
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  } else if (cleaned.length > 0) {
    // Show partial formatting as user types
    if (cleaned.length <= 3) {
      return `(${cleaned}`;
    } else if (cleaned.length <= 6) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    }
  }
  
  return ''; // Return empty string if no digits
};